// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WeYA","label":"styles_label__1KgKI"};